'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import UIAlert from './UIAlert';

const UIFloatingAlert = props => {
  const {
    children,
    className,
    closeable
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["children", "className", "closeable"]);

  return /*#__PURE__*/_jsx(UIAlert, Object.assign({}, rest, {
    className: classNames('private-floating-alert', className),
    closeable: closeable,
    children: children
  }));
};

UIFloatingAlert.propTypes = Object.assign({}, UIAlert.propTypes);
UIFloatingAlert.defaultProps = Object.assign({}, UIAlert.defaultProps, {
  closeable: true
});
UIFloatingAlert.displayName = 'UIFloatingAlert';
export default UIFloatingAlert;